<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.nursingCare.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">介護休業・短時間勤務取得者数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>介護休業<br>取得者</th>
              <th>短時間勤務<br>取得者数</th>
              <th>合計</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="nursingCare.maleNursingCareCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="nursingCare.maleShortTimeCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleCount" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="nursingCare.femaleNursingCareCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="nursingCare.femaleShortTimeCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleCount" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNursingCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfShortTimeCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementNursingCareLeave" :unit="this.unit"/></strong></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->
    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
              <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(nursingCare.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(nursingCare.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の介護休業・短時間勤務取得者数データ
    nursingCare: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '名',
      unit2:'名',
    }
  },
  computed: {
    sumOfMaleCount() {

      if ( !(this.nursingCare.maleNursingCareCount!=null && this.nursingCare.maleShortTimeCount!=null) ) {
        return null;
      }else if ( String(this.nursingCare.maleNursingCareCount).length * String(this.nursingCare.maleShortTimeCount).length == 0) {
        return null;
      }else if ( isNaN(this.nursingCare.maleNursingCareCount) || isNaN(this.nursingCare.maleShortTimeCount)) {
        return null;
      }else{
        return Number(this.nursingCare.maleNursingCareCount) + Number(this.nursingCare.maleShortTimeCount);
      }
    },
    sumOfFemaleCount() {
      if ( !(this.nursingCare.femaleNursingCareCount!=null && this.nursingCare.femaleShortTimeCount!=null) ) {
        return null;
      }else if ( String(this.nursingCare.femaleNursingCareCount).length * String(this.nursingCare.femaleShortTimeCount).length == 0) {
        return null;
      }else if ( isNaN(this.nursingCare.femaleNursingCareCount) || isNaN(this.nursingCare.femaleShortTimeCount)) {
        return null;
      }else{
        return Number(this.nursingCare.femaleNursingCareCount) + Number(this.nursingCare.femaleShortTimeCount);
      }
    },
    sumOfNursingCount() {
      if ( !(this.nursingCare.maleNursingCareCount!=null && this.nursingCare.femaleNursingCareCount!=null) ) {
        return null;
      }else if ( String(this.nursingCare.maleNursingCareCount).length * String(this.nursingCare.femaleNursingCareCount).length == 0) {
        return null;
      }else if ( isNaN(this.nursingCare.maleNursingCareCount) || isNaN(this.nursingCare.femaleNursingCareCount)) {
        return null;
      }else{
        return Number(this.nursingCare.maleNursingCareCount) + Number(this.nursingCare.femaleNursingCareCount);
      }
    },
    sumOfShortTimeCount() {
      if ( !(this.nursingCare.maleShortTimeCount!=null && this.nursingCare.femaleShortTimeCount!=null) ) {
        return null;
      }else if ( String(this.nursingCare.maleShortTimeCount).length * String(this.nursingCare.femaleShortTimeCount).length == 0) {
        return null;
      }else if ( isNaN(this.nursingCare.maleShortTimeCount) || isNaN(this.nursingCare.femaleShortTimeCount)) {
        return null;
      }else{
        return Number(this.nursingCare.maleShortTimeCount) + Number(this.nursingCare.femaleShortTimeCount);
      }
    },
    calcAchievementNursingCareLeave() {
      if ( !(this.sumOfNursingCount!=null && this.sumOfShortTimeCount!=null) ) {
        return null;
      }else if ( String(this.sumOfNursingCount).length * String(this.sumOfShortTimeCount).length == 0) {
        return null;
      }else if ( isNaN(this.sumOfNursingCount) || isNaN(this.sumOfShortTimeCount)) {
        return null;
      }else{
        return Number(this.sumOfNursingCount) + Number(this.sumOfShortTimeCount);
      }
    },
  },
  watch: {
    nursingCare() {
      this.inputNursingCare();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputNursingCare() {
      this.$emit("change-nursing-care-detail", {
        nursingCare: this.nursingCare,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
